import React from "react";

const Offcanvas = ({ isOpen, onClose, title, children, width = 400 }) => {
  return (
    <div
      className={`fixed inset-0 z-50 transition-all duration-300 ${
        isOpen ? "visible opacity-100" : "invisible opacity-0"
      }`}
    >
      {/* Overlay */}
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-300 ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
        onClick={onClose}
      />
      {/* Offcanvas panel */}
      <aside
        className={`fixed right-0 top-0 h-full bg-white dark:bg-navy-800 shadow-lg transition-transform duration-300 ${
          isOpen ? "translate-x-0" : `translate-x-[${width}px]`
        }`}
        style={{ width }}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-navy-700">
          <h2 className="text-lg font-semibold text-navy-700 dark:text-white">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-900 dark:text-gray-300 dark:hover:text-white"
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">{children}</div>
      </aside>
    </div>
  );
};

export default Offcanvas; 